import React from "react";
import CheckoutPage from "../components/checkout/CheckoutPage";

export default function Checkout(props: any) {
    return (
        <CheckoutPage />
    );
}
